import type { Action } from '@reduxjs/toolkit'
import { fileKeyOf } from '../../Model/OrderWizard/OrderWizardDraft.ts'
import { orderWizardActions } from '../../Flux/Slice/OrderWizard/OrderWizardSlice.ts'
import { attachFileHandles } from './fileHandles.ts'

/**
 * Keeps the dropped `File` objects out of the store: they go to the handle registry, the action carries
 * their keys. `pool` (0-based) is where new FASTQ files go; absent, the first pool.
 */
export const dropFiles = (draftId: string, files: readonly File[], dispatch: (action: Action) => void, pool?: number) => {
  const keyed = files.map((file) => ({ key: fileKeyOf(file), file }))
  attachFileHandles(draftId, keyed)
  dispatch(orderWizardActions.filesDropped({ draftId, keys: keyed.map(({ key }) => key), ...(pool ? { pool } : {}) }))
}
